import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Line } from "@ant-design/plots";

const AverageBarPathChart = (props) => {
  const { averageBarPath } = props.optionsResults.metrics;
  const { targetGainPercent } = props.optionsResults.params;

  // x is a string so the axis is categorical: the shared tooltip then snaps to
  // the nearest bar instead of interpolating on a continuous numeric axis.
  const data = averageBarPath
    .flatMap((point) => [
      { bar: point.day, value: point.avgReturn, series: "All (average)" },
      { bar: point.day, value: point.medianReturn, series: "All (median)" },
      {
        bar: point.day,
        value: point.winnerAvgReturn,
        series: "Winners (average)",
      },
      {
        bar: point.day,
        value: point.missAvgReturn,
        series: "Misses (average)",
      },
      { bar: point.day, value: targetGainPercent, series: "Target" },
    ])
    .filter((d) => d.value !== null && d.value !== undefined)
    .map((d) => ({ ...d, bar: String(d.bar) }));

  const config = {
    data,
    xField: "bar",
    yField: "value",
    seriesField: "series",
    point: { shape: "circle" },
    xAxis: { type: "cat" },
    legend: { position: "top" },
    tooltip: {
      shared: true,
      showMarkers: true,
      showCrosshairs: true,
      crosshairs: { type: "x" },
    },
  };

  return (
    <GenericCard
      title="Average signal trajectory"
      tooltipText="Close-to-entry return by bar across signals: all signals (average/median), winners only (hit the target within the window) and misses only. Winners keep being tracked after their hit bar, so their line shows what happens after the target is reached, not just the path to it."
      maxHeight={500}
      isCardOpenByDefault={false}
      className="table-card"
    >
      <Line {...config} height={350} autoFit={false} />
    </GenericCard>
  );
};

AverageBarPathChart.propTypes = { optionsResults: PropTypes.object };

export default AverageBarPathChart;
